<!-- Support — design: erp-design/screens/10-support.html, logika: 23-logic.js supportVals() -->
<div class="sup">

  <!-- Fejléc -->
  <div class="sup__head">
    <div class="sup__head-text">
      <h1 class="stk-page-title">Support</h1>
      <div class="stk-page-sub">Vevői problémák kezelése — húzd a taskokat az oszlopok között.</div>
    </div>
    <!-- Burkoló csak a mobil nézethez (asztalon display: contents — a gombok a fejléc flex-elemei maradnak) -->
    <div class="sup__actions">
    <button type="button" class="sup__rem-btn" [class.sup__rem-btn--on]="remOpen" (click)="toggleRem()" title="Saját emlékeztetők">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"></circle><line x1="12" y1="13" x2="12" y2="9"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
      Emlékeztetők
      <span class="sup__rem-count" *ngIf="openReminderCount > 0" [class.sup__rem-count--overdue]="remHasOverdue">{{ openReminderCount }}</span>
    </button>
    <div class="sup__view" title="Kártyák megjelenítése">
      <button type="button" class="sup__view-btn" [class.sup__view-btn--on]="compact" (click)="setCompact(true)">Kompakt</button>
      <button type="button" class="sup__view-btn" [class.sup__view-btn--on]="!compact" (click)="setCompact(false)">Részletes</button>
    </div>
    <button type="button" class="sup__kb-btn" routerLink="/support/kezikonyv">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5 V5 a2 2 0 0 1 2 -2 h14 v17 H6 a2 2 0 0 0 0 4 h14 v-4"></path></svg>
      Kézikönyv
    </button>
    </div>
  </div>

  <!-- Kanban tábla -->
  <div class="sup-board" #boardEl [class.sup-board--compact]="compact">
    <div class="sup-col" *ngFor="let col of board; trackBy: trackColumn"
         (dragover)="onDragOver($event)" (drop)="onDrop(col)">
      <div class="sup-col__head" *ngIf="colForm?.id !== col.id">
        <span class="sup-col__dot" [style.background]="col.color"></span>
        <span class="sup-col__name" title="Kattints a szerkesztéshez" (click)="editColumn(col, $event)">{{ col.key }}</span>
        <span class="sup-col__count">{{ col.cards.length }}</span>
        <button type="button" class="sup-col__add" title="Új task ebben az oszlopban" (click)="addTask(col)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        </button>
        <!-- Oszlop-eszközök: csak hoverre látszanak (balra, jobbra, szerkesztés, törlés) -->
        <span class="sup-col__tools">
          <button type="button" class="sup-col__add" title="Balra" [disabled]="colReordering || board.indexOf(col) === 0" (click)="moveColumn(col, -1, $event)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15,5 8,12 15,19"></polyline></svg>
          </button>
          <button type="button" class="sup-col__add" title="Jobbra" [disabled]="colReordering || board.indexOf(col) === board.length - 1" (click)="moveColumn(col, 1, $event)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,5 16,12 9,19"></polyline></svg>
          </button>
          <button type="button" class="sup-col__add" title="Oszlop szerkesztése" (click)="editColumn(col, $event)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 l4 -1 l11 -11 a1.5 1.5 0 0 0 0 -2.2 l-0.8 -0.8 a1.5 1.5 0 0 0 -2.2 0 L5 16 z"></path></svg>
          </button>
          <button type="button" class="sup-col__add sup-col__del" title="Oszlop törlése" (click)="askDeleteColumn(col, $event)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
          </button>
        </span>
      </div>

      <!-- Oszlop szerkesztése a fejléc helyén: név, szín, „kész" -->
      <form class="sup-col__new-form sup-col__edit-form" *ngIf="colForm && colForm.id === col.id" (ngSubmit)="saveColumn()">
        <input class="sup-col__new-input" type="text" name="colEditName" [(ngModel)]="colForm.name" placeholder="Oszlop neve…" maxlength="32" autocomplete="off" autofocus>
        <div class="sup-modal__swatches">
          <span class="sup-modal__swatch" *ngFor="let color of labelSwatches" [style.background]="color"
                [class.sup-modal__swatch--on]="colForm.color === color" (click)="colForm.color = color"></span>
        </div>
        <label class="sup-col__new-check">
          <input type="checkbox" name="colEditDone" [(ngModel)]="colForm.isDone">
          <span>„Kész” oszlop</span>
        </label>
        <div class="sup-col__new-actions">
          <button type="button" class="sup-col__delpop-cancel" (click)="cancelColumnForm()" [disabled]="colSaving">Mégse</button>
          <button type="submit" class="sup-col__delpop-ok" [disabled]="colSaving || !colForm.name.trim()">{{ colSaving ? 'Mentés…' : 'Mentés' }}</button>
        </div>
      </form>

      <!-- Oszlop törlése: ha vannak taskok, előbb megkérdezzük, hova kerüljenek. -->
      <div class="sup-col__delpop" *ngIf="colDelete?.column?.id === col.id">
        <div class="sup-col__delpop-title">„{{ col.key }}” oszlop törlése</div>
        <ng-container *ngIf="col.cards.length > 0; else emptyDelete">
          <div class="sup-col__delpop-text">{{ col.cards.length }} task van benne. Melyik oszlopba kerüljenek?</div>
          <select class="sup-col__delpop-select" [(ngModel)]="colDelete!.moveTo">
            <option *ngFor="let other of otherColumns(col)" [ngValue]="other.id">{{ other.key }}</option>
          </select>
        </ng-container>
        <ng-template #emptyDelete>
          <div class="sup-col__delpop-text">Az oszlop üres, törölhető.</div>
        </ng-template>
        <div class="sup-col__delpop-actions">
          <button type="button" class="sup-col__delpop-cancel" (click)="cancelDeleteColumn()" [disabled]="colDeleting">Mégse</button>
          <button type="button" class="sup-col__delpop-ok" (click)="confirmDeleteColumn()" [disabled]="colDeleting || (col.cards.length > 0 && !colDelete?.moveTo)">
            {{ colDeleting ? 'Törlés…' : (col.cards.length > 0 ? 'Átmozgat és töröl' : 'Törlés') }}
          </button>
        </div>
      </div>

      <div class="sup-col__body">
        <div class="sup-card" *ngFor="let card of col.cards; trackBy: trackCard" [class.sup-card--compact]="compact"
             draggable="true" (dragstart)="onDragStart(card)" (click)="openTicket(card)">
          <div class="sup-card__chips" *ngIf="!compact && (card.shopName || card.labels.length > 0)">
            <span class="sup-card__shop" *ngIf="card.shopName" [style.color]="card.shopColor">
              <span class="sup-card__shop-dot" [style.background]="card.shopColor"></span>{{ card.shopName }}
            </span>
            <span class="sup-card__label" *ngFor="let label of card.labels" [style.background]="label.color">{{ label.name }}</span>
          </div>
          <div class="sup-card__title">{{ card.title }}</div>
          <div class="sup-card__excerpt" *ngIf="!compact">{{ card.excerpt }}</div>
          <div class="sup-card__order" *ngIf="!compact && card.orderLabel">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,4 6,4 8.4,14.5 18.6,14.5 20.6,7.5 7.2,7.5"></polyline><circle cx="9.4" cy="19" r="1.5"></circle><circle cx="17.4" cy="19" r="1.5"></circle></svg>
            <span class="sup-card__order-label">{{ card.orderLabel }}</span>
          </div>
          <div class="sup-card__deadline-row" *ngIf="card.deadline">
            <span class="sup-card__deadline" [style.color]="card.deadline.color" [style.background]="card.deadline.bg">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"></circle><line x1="12" y1="13" x2="12" y2="9"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
              {{ card.deadline.label }}
            </span>
          </div>
          <div class="sup-card__foot">
            <span class="sup-card__prio" [ngClass]="card.prioClass">{{ card.prioLabel }}</span>
            <span class="sup-card__date" [title]="card.ticket.displayId">{{ card.ticket.displayId }} · {{ card.dateLabel }}</span>
            <span class="sup-card__mail" *ngIf="card.ticket.mailThreads?.length" title="Kapcsolt levelezés">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
            </span>
            <span class="sup-card__spacer"></span>
            <!-- jobb oldali csoport egyben marad; ha nem fér ki, egészben a következő sorba kerül -->
            <span class="sup-card__foot-right">
            <span class="sup-card__unread" *ngIf="card.ticket.unreadComments > 0"
                  [title]="'Új hozzászólás: ' + (card.ticket.unreadCommentAuthors.join(', ') || 'valaki')">
              {{ card.ticket.unreadComments }} új
            </span>
            <span class="sup-card__comments" *ngIf="card.commentCount > 0">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 1 0 -3.1 6.3 L21 20 Z"></path></svg>
              {{ card.commentCount }}
            </span>
            <span class="sup-card__avatars">
              <span class="sup-avatar sup-avatar--24" *ngFor="let avatar of card.avatars"
                    [style.background]="avatar.color" [title]="avatar.title"
                    [appUserAvatar]="avatar.title">{{ avatar.initial }}</span>
            </span>
            </span>
          </div>
        </div>

        <div class="sup-col__empty" *ngIf="col.cards.length === 0 && !loading">Húzz ide egy taskot</div>
      </div>
    </div>

    <!-- Új oszlop -->
    <div class="sup-col sup-col--new">
      <button type="button" class="sup-col__new-btn" *ngIf="!colForm || colForm.id !== null" (click)="openColumnForm()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        Új oszlop
      </button>
      <form class="sup-col__new-form" *ngIf="colForm && colForm.id === null" (ngSubmit)="saveColumn()">
        <input class="sup-col__new-input" type="text" name="colName" [(ngModel)]="colForm.name" placeholder="Oszlop neve…" maxlength="32" autocomplete="off" autofocus>
        <div class="sup-modal__swatches">
          <span class="sup-modal__swatch" *ngFor="let color of labelSwatches" [style.background]="color"
                [class.sup-modal__swatch--on]="colForm.color === color" (click)="colForm.color = color"></span>
        </div>
        <label class="sup-col__new-check">
          <input type="checkbox" name="colDone" [(ngModel)]="colForm.isDone">
          <span>„Kész” oszlop: az ide kerülő taskoknak nincs élő határidejük, nem kapnak értesítést</span>
        </label>
        <div class="sup-col__new-actions">
          <button type="button" class="sup-col__delpop-cancel" (click)="cancelColumnForm()" [disabled]="colSaving">Mégse</button>
          <button type="submit" class="sup-col__delpop-ok" [disabled]="colSaving || !colForm.name.trim()">{{ colSaving ? 'Mentés…' : 'Létrehozás' }}</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Task modál -->
  <!-- A háttérre kattintás NEM zár be: csak az X gomb, megerősítéssel. -->
  <div class="sup-modal-overlay" *ngIf="modal">
    <div class="sup-modal" (click)="$event.stopPropagation()">

      <div class="sup-modal__head">
        <span class="sup-avatar sup-avatar--30" [style.background]="modal.creatorAvatar.color"
              [title]="modal.creatorAvatar.title"
              [appUserAvatar]="modal.creatorAvatar.title">{{ modal.creatorAvatar.initial }}</span>
        <div class="sup-modal__head-main">
          <input #titleInput class="sup-modal__title-input" [(ngModel)]="modal.draft.title" placeholder="Task címe…">
          <div class="sup-modal__meta">{{ modal.metaLine }}</div>
        </div>
        <button type="button" class="sup-modal__close" title="Bezárás" (click)="closeModal()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>

      <!-- SLA határidő sáv -->
      <div class="sup-modal__deadline" *ngIf="modalDeadline as deadline" [style.background]="deadline.bg">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="deadline.color" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8.5"></circle><line x1="12" y1="13" x2="12" y2="8.5"></line><line x1="12" y1="13" x2="15" y2="15"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
        <span class="sup-modal__deadline-label" [style.color]="deadline.color">{{ deadline.label }}</span>
        <span class="sup-modal__deadline-spacer"></span>
        <span class="sup-modal__deadline-due">Határidő: {{ deadline.dueStr }}</span>
        <span class="sup-modal__deadline-sla">{{ modalSlaText }}</span>
      </div>

      <div class="sup-modal__grid">
        <!-- Bal oldal -->
        <div class="sup-modal__left">
          <div class="sup-box">
            <div class="sup-box__kicker">Leírás</div>
            <textarea class="sup-modal__desc" rows="4" [(ngModel)]="modal.draft.description"
                      placeholder="Írd le a problémát…"></textarea>
            <div class="sup-box__kicker sup-box__kicker--gap">Csatolt képek</div>
            <div class="sup-modal__imgs">
              <!-- Feltöltött képek -->
              <div class="sup-modal__img-slot sup-modal__img-slot--filled" *ngFor="let file of modalAttachments">
                <img [appFetchSupportImage]="file" alt="Csatolt kép" (click)="openLightbox(file)">
                <button type="button" class="sup-modal__img-del" title="Kép törlése"
                        (click)="removeAttachment(file); $event.stopPropagation()">×</button>
              </div>
              <!-- Még nem mentett képek (új task) -->
              <div class="sup-modal__img-slot sup-modal__img-slot--filled" *ngFor="let img of modalPendingImages; index as i">
                <img [src]="img.previewUrl" alt="Feltöltésre váró kép">
                <span class="sup-modal__img-pending" title="A task mentésekor töltődik fel">új</span>
                <button type="button" class="sup-modal__img-del" title="Kép elvetése"
                        (click)="removePendingImage(i); $event.stopPropagation()">×</button>
              </div>
              <div class="sup-modal__img-slot" *ngFor="let slot of emptyImgSlots">Kép</div>
              <label class="sup-modal__img-add" [class.is-busy]="uploadingImage" title="Kép hozzáadása">
                <input type="file" accept="image/*" multiple hidden (change)="onAttachmentSelected($event)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                <span>{{ uploadingImage ? 'Töltés…' : 'Kép' }}</span>
              </label>
            </div>
          </div>

          <div class="sup-box">
            <div class="sup-box__kicker sup-box__kicker--comments">Beszélgetés</div>
            <div class="sup-modal__comments" *ngIf="modalComments.length > 0">
              <div class="sup-comment" *ngFor="let comment of modalComments">
                <span class="sup-avatar sup-avatar--28" [style.background]="comment.avatar.color"
                      [title]="comment.avatar.title"
                      [appUserAvatar]="comment.avatar.title">{{ comment.avatar.initial }}</span>
                <div class="sup-comment__main">
                  <div class="sup-comment__head">
                    <span class="sup-comment__who">{{ comment.who }}</span>
                    <span class="sup-comment__time">{{ comment.time }}</span>
                    <button type="button" class="sup-comment__del" *ngIf="comment.canDelete"
                            title="Saját hozzászólás törlése" (click)="deleteComment(comment)">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
                    </button>
                  </div>
                  <div class="sup-comment__text">{{ comment.text }}</div>
                </div>
              </div>
            </div>
            <div class="sup-modal__comment-row">
              <input class="sup-modal__comment-input" [(ngModel)]="modal.comment"
                     (keydown.enter)="onCommentKeydown($event)" placeholder="Írj hozzászólást…">
              <button type="button" class="sup-modal__comment-send" (click)="sendComment()">Küldés</button>
            </div>
          </div>
        </div>

        <!-- Jobb oldal -->
        <div class="sup-modal__right">
          <div class="sup-box sup-box--side">
            <div class="sup-box__kicker">Állapot</div>
            <div class="sup-modal__status-row">
              <button type="button" class="sup-status-chip" *ngFor="let col of board"
                      [class.sup-status-chip--on]="modal.draft.status === col.key"
                      (click)="pickStatus(col.key)">{{ col.key }}</button>
            </div>
            <div class="sup-box__kicker sup-box__kicker--gap">Prioritás</div>
            <div class="sup-modal__prio-col">
              <button type="button" class="sup-prio-chip" *ngFor="let prio of prioKeys"
                      [class.sup-prio-chip--on]="modal.draft.priority === prio"
                      (click)="pickPriority(prio)">
                <span class="sup-prio-chip__label">{{ prios[prio].label }}</span>
                <span class="sup-prio-chip__sub">{{ prios[prio].sub }}</span>
              </button>
            </div>
          </div>

          <div class="sup-box sup-box--side">
            <div class="sup-box__kicker">Felelősök</div>
            <div class="sup-modal__people">
              <button type="button" class="sup-rem__person" *ngFor="let person of people"
                      [class.sup-rem__person--on]="isAssignee(person.id)"
                      [title]="person.fullName" (click)="toggleAssignee(person.id)">
                <span class="sup-avatar sup-avatar--24" [style.background]="personAvatar(person).color"
                      [appUserAvatar]="personAvatar(person).title">{{ personAvatar(person).initial }}</span>
                <span class="sup-rem__person-name">{{ person.fullName }}</span>
              </button>
            </div>
            <div class="sup-modal__order-note">{{ modalAssigneeNames ? 'A határidő előtt 1 órával e-mailt kap: ' + modalAssigneeNames : 'Felelős nélkül a létrehozó kapja a határidő előtti e-mailt.' }}</div>
          </div>

          <div class="sup-box sup-box--side">
            <div class="sup-box__kicker">Webshop</div>
            <div class="sup-modal__chip-wrap">
              <button type="button" class="sup-dot-chip" *ngFor="let shop of shops"
                      [class.sup-dot-chip--on]="modal.draft.shop === shop"
                      [style.background]="modal.draft.shop === shop ? shopColors[shop] : null"
                      [style.border-color]="modal.draft.shop === shop ? shopColors[shop] : null"
                      (click)="toggleShop(shop)">
                <span class="sup-dot-chip__dot" *ngIf="modal.draft.shop !== shop" [style.background]="shopColors[shop]"></span>
                {{ shop }}
              </button>
            </div>
          </div>

          <div class="sup-box sup-box--side">
            <div class="sup-box__kicker">Címkék</div>
            <div class="sup-modal__chip-wrap sup-modal__chip-wrap--labels">
              <span class="sup-label-chip" *ngFor="let label of labels">
                <button type="button" class="sup-dot-chip"
                        [class.sup-dot-chip--on]="isLabelOn(label)"
                        [style.background]="isLabelOn(label) ? label.color : null"
                        [style.border-color]="isLabelOn(label) ? label.color : null"
                        (click)="toggleLabel(label)">
                  <span class="sup-dot-chip__dot" *ngIf="!isLabelOn(label)" [style.background]="label.color"></span>
                  {{ label.name }}
                </button>
                <button type="button" class="sup-label-chip__del" title="Címke törlése"
                        (click)="deleteLabel(label, $event)">
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                </button>
              </span>
              <span class="sup-modal__no-label" *ngIf="labels.length === 0">Még nincs címke — hozz létre egyet.</span>
            </div>
            <button type="button" class="sup-modal__new-label" *ngIf="!modal.labelFormOpen"
                    (click)="openLabelForm()">+ Új címke</button>
            <div class="sup-modal__label-form" *ngIf="modal.labelFormOpen">
              <input class="sup-modal__label-input" [(ngModel)]="modal.newLabelName" placeholder="Címke neve…">
              <div class="sup-modal__swatches">
                <span class="sup-modal__swatch" *ngFor="let color of labelSwatches"
                      [style.background]="color"
                      [class.sup-modal__swatch--on]="modal.newLabelColor === color"
                      (click)="pickSwatch(color)"></span>
              </div>
              <button type="button" class="sup-modal__label-create" (click)="createLabel()">Létrehozás</button>
            </div>
          </div>

          <div class="sup-box sup-box--side">
            <div class="sup-box__kicker">Kapcsolt rendelés</div>
            <div class="sup-modal__order" *ngIf="modal.draft.order as order">
              <div class="sup-modal__order-box">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,4 6,4 8.4,14.5 18.6,14.5 20.6,7.5 7.2,7.5"></polyline><circle cx="9.4" cy="19" r="1.5"></circle><circle cx="17.4" cy="19" r="1.5"></circle></svg>
                <span class="sup-modal__order-label">{{ orderLabelOf(order) }}</span>
                <button type="button" class="sup-modal__order-remove" title="Rendelés leválasztása" (click)="removeOrder()">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                </button>
              </div>
              <button type="button" class="sup-modal__order-open" (click)="openOrder()">
                Rendelés megnyitása
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="13,6 19,12 13,18"></polyline></svg>
              </button>

              <!-- A kapcsolt rendelés nyomkövetése. Ugyanaz a komponens, mint a
                   rendelés oldalán, szűkített (compact) módban. A blokk a
                   kapcsolt rendelés *ngIf-jén belül van, ezért a rendelés
                   leválasztásakor a tracking is eltűnik. -->
              <app-tracking-panel [orderId]="order.orderId" [compact]="true"></app-tracking-panel>
            </div>
            <ng-container *ngIf="!modal.draft.order">
              <input class="sup-modal__order-search" [ngModel]="modal.ordSearch"
                     (ngModelChange)="onOrderSearchChange($event)" placeholder="Keresés név vagy order ID…">
              <div class="sup-modal__order-results" *ngIf="modal.ordResults.length > 0">
                <div class="sup-modal__order-result" *ngFor="let result of modal.ordResults" (click)="pickOrder(result)">
                  <div class="sup-modal__order-result-name">{{ result.name }}</div>
                  <div class="sup-modal__order-result-meta">{{ result.meta }}</div>
                </div>
              </div>
              <div class="sup-modal__order-note">Nem kötelező — task rendelés nélkül is létezhet.</div>
            </ng-container>
          </div>

          <div class="sup-box sup-box--side" *ngIf="canSeeMail">
            <div class="sup-box__kicker">Kapcsolt levelezés</div>
            <div class="sup-modal__mail" *ngFor="let thread of modal.draft.mailThreads">
              <div class="sup-modal__order-box sup-modal__mail-box" title="Beszélgetés megnyitása" (click)="openMailThread(thread)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
                <span class="sup-modal__order-label"><strong>{{ thread.displayId }}</strong> · {{ thread.subject }}</span>
                <button type="button" class="sup-modal__order-remove" title="Levelezés leválasztása" (click)="removeMailThread(thread); $event.stopPropagation()">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                </button>
              </div>
              <div class="sup-modal__order-note sup-modal__mail-who">{{ thread.customerName || thread.customerEmail }}{{ thread.status === 'closed' ? ' · lezárva' : '' }}</div>
            </div>
            <input class="sup-modal__order-search" [ngModel]="modal.mailSearch"
                   (ngModelChange)="onMailSearchChange($event)" placeholder="Keresés: L-szám, tárgy, név, e-mail…">
            <div class="sup-modal__order-results" *ngIf="modal.mailResults.length > 0">
              <div class="sup-modal__order-result" *ngFor="let result of modal.mailResults" (click)="pickMailThread(result)">
                <div class="sup-modal__order-result-name">{{ result.displayId }} · {{ result.subject }}</div>
                <div class="sup-modal__order-result-meta">{{ result.customerName || result.customerEmail }}</div>
              </div>
            </div>
            <div class="sup-modal__order-note" *ngIf="!modal.draft.mailThreads.length">Nem kötelező — a Levelezésből is nyitható task.</div>
          </div>

          <button type="button" class="sup-modal__delete" (click)="deleteTask()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
            Task törlése
          </button>
        </div>
      </div>

      <div class="sup-modal__foot">
        <span class="sup-modal__foot-note">A módosítások csak mentésre kerülnek át a táblára — a hozzászólások azonnal megjelennek.</span>
        <button type="button" class="sup-modal__cancel" (click)="closeModal()">Mégse</button>
        <button type="button" class="sup-modal__save" [disabled]="saving" (click)="save()">Mentés</button>
      </div>
    </div>
  </div>

  <!-- Kép lightbox (csatolmány-URL esetén) -->
  <div class="sup-lightbox" *ngIf="lightboxUrl || lightboxFile" (click)="closeLightbox()">
    <img class="sup-lightbox__img" *ngIf="lightboxFile" [appFetchSupportImage]="lightboxFile" alt="Csatolt kép">
    <img class="sup-lightbox__img" *ngIf="!lightboxFile && lightboxUrl" [src]="lightboxUrl" alt="Csatolt kép">
    <button type="button" class="sup-lightbox__close" title="Bezárás" (click)="closeLightbox()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
    </button>
  </div>

  <!-- Emlékeztetők panel: jobbról nyílik be, mindent lefed (háttér elsötétül).
       A fejléc „Emlékeztetők" gombja nyitja; Esc, a háttér vagy az X csukja. -->
  <div class="sup-drawer" *ngIf="remOpen">
    <div class="sup-drawer__backdrop" (click)="closeRem()"></div>
    <div class="sup-drawer__panel" role="dialog" aria-label="Saját emlékeztetők">
      <button type="button" class="sup-drawer__close" title="Bezárás" (click)="closeRem()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
      </button>
      <div class="sup-rem sup-rem--drawer">
        <div class="sup-rem__head">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"></circle><line x1="12" y1="13" x2="12" y2="9"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
          <span class="sup-rem__title">Saját emlékeztetők</span>
          <span class="sup-rem__count" *ngIf="openReminderCount > 0">{{ openReminderCount }}</span>
          <button type="button" class="sup-rem__add" *ngIf="!remForm" (click)="openReminderForm()">+ Új</button>
        </div>
        <div class="sup-drawer__hint">A határidő előtt 1 órával e-mailt kapnak a felelősök.</div>
    
        <!-- Mini űrlap (új és szerkesztés) -->
        <form class="sup-rem__form" *ngIf="remForm" (ngSubmit)="saveReminder()">
          <input class="sup-rem__input sup-rem__input--title" type="text" name="remTitle" [(ngModel)]="remForm.title"
                 placeholder="Mire emlékeztessen? (pl. visszahívni a vevőt)" maxlength="255" autocomplete="off" autofocus>
          <textarea class="sup-rem__input sup-rem__input--desc" name="remDesc" rows="2" [(ngModel)]="remForm.description"
                    placeholder="Rövid leírás (nem kötelező)"></textarea>
          <div class="sup-rem__row">
            <label class="sup-rem__due">
              <span class="sup-rem__k">Határidő</span>
              <input type="datetime-local" name="remDue" [(ngModel)]="remForm.due">
              <button type="button" class="sup-rem__due-clear" *ngIf="remForm.due" title="Nincs határidő" (click)="remForm.due = ''">×</button>
            </label>
            <div class="sup-rem__people">
              <span class="sup-rem__k">Felelősök</span>
              <button type="button" class="sup-rem__person" *ngFor="let person of people"
                      [class.sup-rem__person--on]="isReminderAssignee(person.id)"
                      [title]="person.fullName" (click)="toggleReminderAssignee(person.id)">
                <span class="sup-avatar sup-avatar--24" [style.background]="personAvatar(person).color"
                      [appUserAvatar]="personAvatar(person).title">{{ personAvatar(person).initial }}</span>
                <span class="sup-rem__person-name">{{ person.fullName }}</span>
              </button>
            </div>
          </div>
          <div class="sup-rem__actions">
            <span class="sup-rem__note" *ngIf="!remForm.due">Határidő nélkül nincs értesítés, csak jegyzet.</span>
            <span class="sup-rem__note" *ngIf="remForm.due && !remForm.assigneeIds.length">Felelős nélkül te kapod az értesítést.</span>
            <button type="button" class="sup-rem__cancel" (click)="cancelReminderForm()" [disabled]="remSaving">Mégse</button>
            <button type="submit" class="sup-rem__save" [disabled]="remSaving || !remForm.title.trim()">{{ remSaving ? 'Mentés…' : (remForm.id === null ? 'Létrehozás' : 'Mentés') }}</button>
          </div>
        </form>
    
        <div class="sup-rem__list" *ngIf="reminderVms.length">
          <div class="sup-rem__item" *ngFor="let vm of reminderVms" [class.sup-rem__item--done]="vm.done"
               [class.sup-rem__item--overdue]="vm.deadline?.overdue" (click)="openReminderForm(vm.reminder)">
            <button type="button" class="sup-rem__check" [class.sup-rem__check--on]="vm.done"
                    [title]="vm.done ? 'Újranyitás' : 'Kész'" (click)="toggleReminderDone(vm, $event)">
              <svg *ngIf="vm.done" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
            </button>
            <div class="sup-rem__main">
              <div class="sup-rem__item-title">{{ vm.reminder.title }}</div>
              <div class="sup-rem__item-desc" *ngIf="vm.reminder.description">{{ vm.reminder.description }}</div>
            </div>
            <span class="sup-rem__deadline" *ngIf="vm.deadline" [style.color]="vm.deadline.color" [style.background]="vm.deadline.bg"
                  [title]="'Határidő: ' + vm.dueStr">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"></circle><line x1="12" y1="13" x2="12" y2="9"></line><line x1="9" y1="2.5" x2="15" y2="2.5"></line></svg>
              {{ vm.deadline.label }} · {{ vm.dueStr }}
            </span>
            <span class="sup-rem__deadline sup-rem__deadline--none" *ngIf="!vm.deadline && !vm.done">nincs határidő</span>
            <span class="sup-rem__deadline sup-rem__deadline--none" *ngIf="vm.done">kész</span>
            <span class="sup-card__avatars">
              <span class="sup-avatar sup-avatar--24" *ngFor="let avatar of vm.avatars"
                    [style.background]="avatar.color" [title]="avatar.title"
                    [appUserAvatar]="avatar.title">{{ avatar.initial }}</span>
            </span>
            <button type="button" class="sup-rem__del" title="Törlés" (click)="deleteReminder(vm, $event)">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
            </button>
          </div>
        </div>
        <div class="sup-rem__empty" *ngIf="!reminderVms.length && !remForm && !loading">Nincs emlékeztető. A „+ Új” gombbal írhatsz egyet, határidővel vagy anélkül.</div>
      </div>
    </div>
  </div>
</div>
